module.exports = __webpack_public_path__ + "img/cancel-full-screen-dark.b41d77da.svg";